import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FsessionService } from 'src/app/servicios/session/fsession.service';

export const ExpirationEnviromentGuard: CanActivateFn = () => {
  const router = inject(Router);
  const fse    = inject(FsessionService);

  const now = new Date();
  const env = environment.entorno;
  const fechaDev     = new Date(fse.optenerValor('fecha_caducidad_dev'));
  const fechaPreview = new Date(fse.optenerValor('fecha_caducidad_preview'));

  if (env === 'Development' && fechaDev.getTime() > now.getTime()) {
    router.navigate(['/login-failed']);
    fse.agregarActualizar("error_acceso_enviroment", "true");
  }
  if (env === 'Beta' && fechaPreview.getTime() > now.getTime()) {
    router.navigate(['/login-failed']);
    fse.agregarActualizar("error_acceso_enviroment", "true");
  }
  if (env === 'Local') {

  }
  return true;
};
